module.exports = __webpack_public_path__ + "static/img/s2.95b5157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s2.png
// module id = 9wt+
// module chunks = 0